import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaBook, FaQuestionCircle, FaUser, FaCog, FaClipboard, FaClipboardList, FaAngleDown, FaAngleUp, FaListAlt, FaAngellist, FaRegFileExcel, FaRegAddressCard, FaCampground, FaQuidditch, FaAlgolia } from 'react-icons/fa';
import { useAuth } from '../../utils/AuthContext';

const Sidebar = () => {
  const { auth } = useAuth();
  const [isUsersMenuOpen, setIsUsersMenuOpen] = useState(false);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const [isPaperSetMenuOpen, setIsPaperSetMenuOpen] = useState(false);
  const [isQuestionCategoryMenuOpen, setIsQuestionCategoryMenuOpen] = useState(false);

  const [isQuestionMenuOpen, setIsQuestionMenuOpen] = useState(false);

  const [isPaperSetAssignMenuOpen, setIsPaperSetAssignMenuOpen] = useState(false);

  

  const toggleUsersMenu = () => {
    setIsUsersMenuOpen(!isUsersMenuOpen);
  };

  const toggleCategoryMenu = () => {
    setIsCategoryMenuOpen(!isCategoryMenuOpen);
  };

  const togglePaperSetMenu = () => {
    setIsPaperSetMenuOpen(!isPaperSetMenuOpen);
  };
  const togglePaperSetAssignMenu = () => {
    setIsPaperSetAssignMenuOpen(!isPaperSetAssignMenuOpen);
  };


  const toggleQuestionCategoryMenu = () => {
    setIsQuestionCategoryMenuOpen(!isQuestionCategoryMenuOpen);
  };

  const toggleQuestionMenu = () => {
    setIsQuestionMenuOpen(!isQuestionMenuOpen);
  };

  return (
    <div className="bg-gray-800 rounded-2xl text-white w-64 h-full flex flex-col fixed top-0 left-0">
      <div className="p-4 mt-4 ml-2 mr-2 block rounded-2xl px-2 py-2 card-view flex items-center">
        <img src="/tsplLogo.png" alt="Logo" className="h-6 w-6 mr-2" />
        <h2 className="text-sm font-bold text-primary">TSPL Exam</h2>
      </div>

      <div className="p-4 text-center font-bold text-xl">
        {auth.role === 'admin' ? 'Admin Panel' : 'User Panel'}
      </div>
      
      <nav className="flex-1 overflow-y-auto">
        {auth.role === 'admin' ? (
          <>
            <NavLink to="/admin" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaHome className="inline mr-2" /> Dashboard
            </NavLink>
            <div className="block px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={toggleCategoryMenu}>
              <FaAngellist className="inline mr-2" /> Category {isCategoryMenuOpen ? <FaAngleUp className="inline ml-2" /> : <FaAngleDown className="inline ml-2" />}
            </div>
            {isCategoryMenuOpen && (
              <div className="ml-4">
                <NavLink to="/admin/category-manager" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Category Manager
                </NavLink>
              </div>
            )}
            <div className="block px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={toggleQuestionCategoryMenu}>
              <FaListAlt className="inline mr-2" /> Question Category {isQuestionCategoryMenuOpen ? <FaAngleUp className="inline ml-2" /> : <FaAngleDown className="inline ml-2" />}
            </div>
            {isQuestionCategoryMenuOpen && (
              <div className="ml-4">
                <NavLink to="/admin/set-question-category" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Set QuestionCategory
                </NavLink>
                <NavLink to="/admin/view-questions-by-category" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  View QuestionsByCategory
                </NavLink>
                <NavLink to="/admin/change-question-category" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Change QuestionCategory
                </NavLink>
              </div>
            )}

          <div className="block px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={toggleQuestionMenu}>
              <FaListAlt className="inline mr-2" /> Questions {isQuestionMenuOpen ? <FaAngleUp className="inline ml-2" /> : <FaAngleDown className="inline ml-2" />}
            </div>
            {isQuestionMenuOpen && (
              <div className="ml-4">
            <NavLink to="/admin/add-question" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaQuestionCircle className="inline mr-2" /> Add New Question
            </NavLink>
            <NavLink to="/admin/view-questions" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaAlgolia className="inline mr-2" /> View All Questions
            </NavLink>
            </div>
            )}

            <div className="block px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={togglePaperSetAssignMenu}>
              <FaClipboard className="inline mr-2" /> Assign PaperSet {isPaperSetAssignMenuOpen ? <FaAngleUp className="inline ml-2" /> : <FaAngleDown className="inline ml-2" />}
            </div>
            {isPaperSetAssignMenuOpen && (
              <div className="ml-4">
            <NavLink to="/admin/paper-sets-page" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaClipboard className="inline mr-2" /> PaperSets
            </NavLink>
            <NavLink to="/admin/view-paper-sets" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaClipboardList className="inline mr-2" /> View Paper Sets
            </NavLink>
            <NavLink to="/admin/assign-paper-set" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaClipboard className="inline mr-2" /> Assign Paper Set
            </NavLink>
            <NavLink to="/admin/view-assigned-paper-sets" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaClipboardList className="inline mr-2" /> View Assigned Paper Sets
            </NavLink>
              </div>
            )}
            
            <div className="block px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={toggleUsersMenu}>
              <FaUser className="inline mr-2" /> Manage Users {isUsersMenuOpen ? <FaAngleUp className="inline ml-2" /> : <FaAngleDown className="inline ml-2" />}
            </div>
            {isUsersMenuOpen && (
              <div className="ml-4">
                <NavLink to="/admin/add-user" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Add User
                </NavLink>
                <NavLink to="/admin/view-users" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  View Users
                </NavLink>
                <NavLink to="/admin/modify-users" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Modify Users
                </NavLink>
              </div>
            )}
            <div className="block px-4 py-2 hover:bg-gray-700 cursor-pointer" onClick={togglePaperSetMenu}>
              <FaClipboard className="inline mr-2" /> Manage PaperSet {isPaperSetMenuOpen ? <FaAngleUp className="inline ml-2" /> : <FaAngleDown className="inline ml-2" />}
            </div>
            {isPaperSetMenuOpen && (
              <div className="ml-4">
                <NavLink to="/admin/assign-questions-paperset" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Assign Questions to Paper Set
                </NavLink>
                <NavLink to="/admin/view-questions-paperset" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  View Questions in Paper Set
                </NavLink>
                <NavLink to="/admin/upload-questions" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
                  Upload Questions
                </NavLink>
              </div>
            )}
            <NavLink to="/admin/exam-result" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaRegAddressCard className="inline mr-2" /> Exam Result
            </NavLink>
            <NavLink to="/admin/all-marksheet" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaCampground className="inline mr-2" /> All Mark Sheet
            </NavLink>

            {/* <NavLink to="/admin/livevideo" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaCampground className="inline mr-2" /> Live Stream
            </NavLink> */}

          
          </>
        ) : (
          <>
            <NavLink to="/user" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaHome className="inline mr-2" /> Dashboard
            </NavLink>
            <NavLink to="/user/start-exam" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaBook className="inline mr-2" /> Start Exam
            </NavLink>
            <NavLink to="/user/result" className={({ isActive }) => isActive ? 'block px-4 py-2 bg-gray-700' : 'block px-4 py-2 hover:bg-gray-700'}>
              <FaClipboardList className="inline mr-2" /> Result
            </NavLink>
          </>
        )}
      </nav>
    </div>
  );
};

export default Sidebar;
